import { BaseQueryFn } from '@reduxjs/toolkit/query'

export function getBaseQuery<TError>() {
  
  const query: BaseQueryFn<Promise<{ data: unknown }>, unknown, TError> = async (args) => {
    return args.then(response => {
      return response
    }).catch((e: TError) => {
      return { error: Object.assign({}, e) }
    })
  }

  return query
}
